import { Middleware } from '@reduxjs/toolkit';

/**
 * Adds databases added to redux store to the YJS store as well.
 * Applies any changes to YJS database to Redux store.
 * Intercepts changesets from being added to draft, adds to YJS instead.
 */
export const yjsMiddleware: Middleware = () => {
  return (next) => (action) => {
    return next(action);
  };
};
